/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Manual_Meeting_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_delete = /** @type {((inputs?: Manual_Meeting_DeleteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_DeleteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer")
	return /** @type {LocalizedString} */ ("Delete")
});